<app-navbar [title]="pageTitle">
	<button mat-raised-button color="primary" class="me-3" (click)="openWWW(service.data.id)">WWW</button>
	<button
		mat-raised-button
		color="primary"
		[disabled]="!service.data.insurance"
		*ngIf="editable"
		(click)="submit(true)"
		class="me-3"
	>
		Zapisz i wyjdź do listy
	</button>
	<button
		mat-raised-button
		color="accent"
		[disabled]="!service.data.insurance"
		*ngIf="editable"
		(click)="submit(false)"
		class="me-3"
	>
		Zapisz i zostań
	</button>
	<button mat-raised-button color="warn" class="me-3" *ngIf="!editable" (click)="editUnlock()">Edycja</button>
	<a class="btn btn-danger" routerLink="../"> <i class="fas fa-chevron-left"></i> Powrót </a>
	@if (pageFunction === 'edit') {
		<a class="btn btn-success mx-3" (click)="copyProduct()"> <i class="fas fa-copy"></i> Kopiuj </a>
	}
</app-navbar>
<mat-card appearance="outlined" class="mat-card-status">
	<mat-card-title
		matTooltip="SZKIC -	świeżo utworzony, w trakcie przygotowania przez działy
   możliwość ręcznej zmiany z AKTYWNY, ARCHIWUM

   OPUBLIKOWANY - posiadający aktualną ofertę-
   automatycznie zmienia na ten status o ile są wypełnione wszystkie wymagane pola
   brak możliwości ręcznej zmiany na ten status

   AKTYWNY - sprawdzony pod względem merytorycznym ale nieposiadający aktualnej oferty
   możliwość ręcznej zmiany z SZKIC, ARCHIWUM ale ! przy weryfikacji systemu czy wszystkie pola są wypełnione

   ARCHIWUM - produkt który biznesowo nie jest już w naszym katalogu a nie chcemy żeby nas zaśmiecał np.Willa Blue Moon -
   możliwość ręcznej zmiany z SZKIC, AKTYWNY
   "
		>Status produktu: {{ getStatus(service.data.status) }}</mat-card-title
	>
</mat-card>
<mat-card appearance="outlined" *ngIf="editable" class="mat-card-editable"
	>Masz niezapisane zmiany! Pamiętaj o ich zapisaniu
</mat-card>
<mat-tab-group class="container" mat-align-tabs="start" mat-stretch-tabs="false" dynamicHeight animationDuration="0ms">
	<mat-tab label="Dane podstawowe">
		<ng-template matTabContent>
			<app-product-basic [editable]="!editable" [pageFunction]="pageFunction" class="container">
			</app-product-basic>
		</ng-template>
	</mat-tab>
	<mat-tab label="Dane dodatkowe">
		<app-product-additional
			[editable]="!editable"
			class="container"
			[documentKinds]="documentKinds"
		></app-product-additional>
	</mat-tab>
	<mat-tab label="Multimedia">
		<app-product-multimedias [editable]="!editable" class="container"></app-product-multimedias>
	</mat-tab>
	<mat-tab label="Opis (autokar)">
		<ng-template matTabContent>
			<app-product-description
				[editable]="!editable"
				[use]="OfferTransportKind.COACH"
				[productKind]="service.data.productKind"
				class="container"
			>
			</app-product-description>
		</ng-template>
	</mat-tab>
	<mat-tab label="Opis (samolot)">
		<ng-template matTabContent>
			<app-product-description
				[editable]="!editable"
				[use]="OfferTransportKind.PLANE"
				[productKind]="service.data.productKind"
				class="container"
			>
			</app-product-description>
		</ng-template>
	</mat-tab>
	<mat-tab label="Pokoje" *ngIf="[1, 2, 5, 7].includes(service.data.productKind)">
		<app-product-rooms [editable]="!editable" class="container"> </app-product-rooms>
	</mat-tab>
	<mat-tab label="Ustawienia cennika produktu">
		<div class="my-4">
			<app-group-offer-price-setting
				[currency]="currency"
				[board]="board"
				[priceSetting]="priceSetting"
				[(priceOption)]="priceOption"
				[editable]="!editable"
				(editableChange)="editable = $event"
				[(productData)]="service.data"
			></app-group-offer-price-setting>

			<hr class="my-4" />

			<mat-form-field class="w-75">
				<textarea
					[disabled]="!editable"
					matInput
					[(ngModel)]="service.data.surchargeProgram.description"
				></textarea>
				<mat-label for="surchargeProgramDescription">Dopłaty wymagane na miejscu</mat-label>
			</mat-form-field>
		</div>
	</mat-tab>
	<mat-tab label="Organizacja"><app-product-organization-config></app-product-organization-config></mat-tab>
	<mat-tab label="Check-listy"
		><app-product-check-list
			(checkListChange)="updateProductByCheckList($event)"
			[editable]="!editable"
		></app-product-check-list
	></mat-tab>
	<mat-tab label="Koszty">
		<app-product-costs></app-product-costs>
	</mat-tab>
	<mat-tab label="Opłaty drogowe">
		<app-product-transit-country-distances [editable]="!editable"></app-product-transit-country-distances>
	</mat-tab>
	@if (pageFunction === 'edit') {
		<mat-tab label="Historia">
			<app-bag-history [requestUrl]="'product/' + service.data.id"></app-bag-history>
		</mat-tab>
	}
</mat-tab-group>
